// TermInfoNarrowList.js
import React, { useEffect, useState } from 'react';
import { Box } from '@mui/system';
import FlexyTable from '../common/flexytable/FlexyTable';
import styled from '@emotion/styled';
import { TermInfoTableColumns as TableColumns } from './TermInfoGql';
import { ContentHeader, HeaderLeft } from '../common/CvoStyled';
import SearchBox from '../common/SearchBox';

const TermInfoListContainer = styled(Box)({
    flexGrow:1, display:'flex', flexDirection:'column'
});

const ColumnTermId = 'termId';

/**
 * 단말기 검색 및 선택으로 상위에서 해당 단말기에 대한 작업을 수행할 수 있도록 함
 * @param {*} param0 
 * @returns 
 */
export default function TermInfoNarrowList({
    itemSelected,
    columnList,
    onClickItem,
    records,
    tools,
}) {
    const [columns, setColumns] = useState([ColumnTermId]);
    const [search, setSearch] = useState('');

    useEffect(()=>{
        const newCols = [];
        for(const col of TableColumns) {
            if(columnList.includes(col.id)) {
                newCols.push(col);
            }
        }
        if(newCols.length===0) newCols.push(ColumnTermId);
        setColumns(newCols);
    }, [columnList]);

    const onChangeSearch = (text) => {
        setSearch(text);
    };

    return (
        <TermInfoListContainer>
            <ContentHeader>
                <HeaderLeft>
                    <SearchBox onChange={onChangeSearch} value={search} width={180}/>
                </HeaderLeft>
            </ContentHeader>
            <FlexyTable
                name="term_info_narrow_list"
                uniqueKey="devId"
                columns={columns}
                records={records}
                selected={itemSelected ? [itemSelected] : null}
                onClickOneRow={onClickItem}
                search={search}
                tools={tools ? tools : []}
                hideFirstTopButton={true}
            />
        </TermInfoListContainer>
    )
}
